<template>
    <div>
      <div class="inbanner bg-cover">
        <el-image src="images/lb/cpyfw.jpg"></el-image>
      <!-- <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">产品中心</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div> -->
    </div>
        <!-- services -->
    <div  >
      <div style="  padding-right:250px;padding-left:280px;"> 	
        <div class="agileinfo_services_grids animate__animated  animate__animated">
          <div class="col-md-3 w3_agile_services_grid animate__animated  animate__backInUp      animate__delay-0.5s	0.5s"   v-for="(item, index) in newlist" :key="index" >
              <div class="bo">
                <!-- <div  style="background-image: url('../img/texture-bw.png');  z-index: -1 !important; opacity:1; " > -->
                  <div  style="  z-index: -1 !important; opacity:1; " > 
                        <div class="background-image">
                            <div style="position: relative; z-index: 991;opacity: 1; ">
                            <!-- <el-image :src="item.productImg"  ></el-image> -->
                            <el-image   :src="item.productImg"  ></el-image>
               
                            </div>
                        </div>
                    
                        <div class="contentP">
                      
                          <h3> {{item.productType}} </h3>
                          <!-- <div class="agile_services_grid1_sub">
                            <p> {{item.createTime}}   </p>
                          </div> -->
                        <div class="agileits_w3layouts_services_grid1">
                          <h4><p @click="gotoDetail(item)"  data-toggle="modal" data-target="#myModal"> {{item.productName}} </p></h4>
                          <!-- <p>{{item.englishName}}</p> -->
                        </div>
                      </div>
                </div>
            </div>
          </div>
          <div class="clearfix"> </div>
        </div>
              <Pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :total="totalItems"
                @page-changed="handlePageChanged"
              />
      </div>
    </div>
<!-- //services -->
    </div>
</template>
<style>
.inbanner {
  position: relative;
  color: #fff;
}
 .inbanner .inwrap.l-m-c {
    z-index: 10;
    top: auto;
    bottom: 25%;
    display: block;
    unicode-bidi: isolate;
    position: absolute;
}

.inwrap {
    max-width: 1280px;
    margin: 0 auto;
    width: 94%;
}
.w3_agile_services_grid:hover {
  background-color: red;
}
.background-image {
   
    position: relative; /* 或者 absolute，具体取决于你的布局需求 */
    z-index: 1 !important; /* 使图片位于底部 */
    /* padding: 20px; */
}
.bo {
  border: 1px solid #bdbdbd;
  padding: 10px;
}
.col-md-3 {
  
    padding: 10px;

    
 
}

.background-image img {
 
  
    width: 100%; /* 或者其他尺寸 */
    height: 249px; /* 保持图片的宽高比 */
}
.contentP {
    float: unset !important;;
    position: relative; /* 如果你想要内容相对于图片定位，则需要设置 */
    z-index: 1; /* 确保内容在图片之上 */
}
.bc {
  background-size:300px 200px;
  height:300px;
  /* width: 300px; */
  background-size: cover; /* 使背景图片铺满整个元素，保持宽高比 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 使背景图片始终固定在元素的中心 */
}
.w3_agile_services_grid {
    margin-top: 0em;  
}
</style>
<script>
import 'animate.css'
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
import Pagination from '@/components/PaginationCom.vue';

export default {
   components: {
      Pagination
    },
   data(){
    return {    
      currentPage: 1,
      pageSize: 10,
      totalItems: 1,  
      newlist:[],
      newsdata:{}
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
          newTitle: '',
          currentPage: this.currentPage,
          type:''
       }
        this.currentPage = newPage;
        http.products.productslist(param).then(res=>{
           console.log(res.data) 
           this.newsdata = res.data,
           this.newlist=res.data.rows
           this.currentPage =newPage;
           this.pageSize=10;
           this.totalItems=res.data.total
        })
      },
   },
   created(){
    this.handlePageChanged(1)
 
   },
   props: {
    user: Object
  },
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
 
    function gotoDetail(item) {
      const state= item
      store.state.productStore.currentProduct=item
      router.push({ name: 'productDetail',state});
    }
    return {
      gotoDetail
    };
  }
}
</script>
